import { Component, Host, Prop, h } from '@stencil/core';

import { AdditionalInsight } from '../../../../interfaces/interface.consumer-market-confidence';

@Component({
  tag: 'additional-insights',
  styleUrl: 'additional-insights.css',
})
export class AdditionalInsights {
  @Prop() additionalInsights: AdditionalInsight[] = [];
  @Prop() shouldDisplayAdditionalInsights: boolean = false;

  render() {
    const { additionalInsights, shouldDisplayAdditionalInsights } = this;
    if (!shouldDisplayAdditionalInsights) {
      return;
    }
    return (
      <Host>
        <div class="@container">
          <div class="flex flex-col text-black bg-clrs-white rounded-lg shadow-drop mb-7 @xs:px-6 @md:px-12 py-6" data-testId="additional-insights">
            <div>
              <h3 class="font-extrabold text-lg font-montserrat">Additional Insights</h3>
              <div class="text-center flex flex-col py-5 @md:pl-7">
                {additionalInsights.map((item) => (
                  <RenderInsightItem item={item} />
                ))}
              </div>
              <div class="flex flex-col text-xxs text-clrs-charcoal">
                {additionalInsights.map((item, index) => (
                  <span key={`disclaimer-${index}`}>{item?.disclaimers}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}

const RenderInsightItem = ({ item }: { item?: AdditionalInsight }) => {
  if (!item.shouldDisplay) {
    return null;
  }

  const { type, description, titlePrice, displayValue, isPositiveValue } = item;
  const priceClass = {
    'font-bold text-center border-solid border-2 rounded-md py-1 px-2 min-w-20 max-h-16 flex flex-col justify-center items-center w-20 @3xl:w-32': true,
    'text-clrs-green border-clrs-green': isPositiveValue,
    'text-clrs-red border-clrs-red': !isPositiveValue,
  };

  return (
    <div class="flex flex-row justify-between mt-2">
      <div class="pr-2">
        <div class="font-bold text-base text-left">{type}</div>
        <div class="text-xs py-2 text-left">{description}</div>
      </div>
      <div class={priceClass}>
        <span class="block text-xs">{titlePrice}</span>
        <span class="whitespace-normal @xs:text-sm @md:text-base">{displayValue}</span>
      </div>
    </div>
  );
};
